import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as trap from 'modules/trap'
import * as popoverModule from 'modules/popover'
import * as toastModule from 'modules/toast'


export default compose(
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected),
        traps: idx(state, _ => _.traps.items),
      }
    }, 
    (dispatch) => {
      const actions = {
        ...trap,
        ...popoverModule,
        ...toastModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      loaded: true,
    }),
    {
      setState: state => object => ({
        ...state,
        ...object
      }),
    }
  ),
  withHandlers({
    onConfirmClick: ({ actions, organisation, data }) => async (uuid, status) => {
      try { 
        await actions.removeUserTrap(uuid)
        actions.showToast(toastModule.SUCCESS_TOAST, status === 'PENDING' ? 'Successfully revoked invitation' : 'Trap user removed')
        actions.getReportTraps(organisation, data.filters, data.setPagination)
        actions.hidePopover()
      // eslint-disable-next-line
      } catch (error) {}
    }, 
    handleUserInvite: ({ actions, organisation, data }) => async (email, trapObject, resetEmail) => {
      try { 
        await actions.inviteUserTrap(email, trapObject)
        resetEmail()
        actions.showToast(toastModule.SUCCESS_TOAST, `${email} has been invited to the trap`)  
        actions.getReportTraps(organisation, data.filters, data.setPagination)
      // eslint-disable-next-line
      } catch (error) {}
    }, 
  }),
  
  lifecycle({
    componentDidMount() {
      const { 
        actions, organisation, data
      } = this.props      
      actions.getReportTraps(organisation, data.filters, data.setPagination)
    },
  }),
)




// WEBPACK FOOTER //
// ./src/components/organisms/ShareTrapIndividualPopover/ShareTrapIndividualPopover.enhancer.js